/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingProductNameRequest {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingProductNameRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingProductNameRequest>): AwsSecurityHubFindingProductNameRequest {
        let obj = Object.assign(new AwsSecurityHubFindingProductNameRequest(), model);
        AwsSecurityHubFindingProductNameRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingProductNameRequest>): AwsSecurityHubFindingProductNameRequest {
        if (!model) return null;
        return AwsSecurityHubFindingProductNameRequest.newInstance(<AwsSecurityHubFindingProductNameRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingProductNameRequest) {
        if (!obj) return;

        models.AwsSecurityHubFindingProductNameRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingProductNameRequest): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingProductNameRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Which tenant Id to fetch product names for
     */
    tenant_id: string;

}
